window.HELIOS = {
	adobe: {
		shared: {},
		tagging: {
			targetCode: '',
			googleAccount: '',
			adobeAccount: '',
			mboxActivated: 'false',
			componentName: '',
			click: { buttonText: '', destination: '', currentPage: '', locationInPage: '' },
			languageCode: '',
			video: {
				autoplay: '',
				name: '',
				interaction: '',
				eventPlay: '',
				eventCompleted: '',
			},
			share: {
				action: '',
				interaction: '',
				network: '',
				url: '',
			},
		},
	},
	components: {},
	config: {
		common: {},
	},
};

const config = {
	dev: 'https://assets.adobedtm.com/de7bac0b5081/1e4d20ecd950/launch-bc2a5305f3eb-development.min.js',
	stage: 'https://assets.adobedtm.com/de7bac0b5081/1e4d20ecd950/launch-171e2e0179b2-staging.min.js',
	prod: 'https://assets.adobedtm.com/de7bac0b5081/1e4d20ecd950/launch-c1ff71c4abd4.min.js',
};

const env = (() => {
	if(window.location.href.indexOf('thenissannext.com') !== -1){
		return 'prod';
	}
	else if(process.env.NODE_ENV === 'production'){
		return 'stage';
	}
	else {
		return 'dev';
	}
})();

if (document.getElementById('adobe_analytics') == null) {
	const script = document.createElement('script');
	script.src = config[env];
	script.id = 'adobe_analytics';
	document.head.appendChild(script);
}

let chain = new Promise((f) => {
	function check() {
		if (window.s?.isReadyToTrack()) {
			f();
		} else {
			setTimeout(check, 10);
		}
	}
	check();
});

function dispatchEvent(eventName) {
	const p = new Promise((f) => {
		function onRes() {
			document.body.removeEventListener(`${eventName}.done`, onRes);
			f();
		}

		document.body.addEventListener(`${eventName}.done`, onRes);
	});

	const event = new Event(eventName);
	document.body.dispatchEvent(event);

	return p;
}

const fns = {
	setVariables: () => dispatchEvent('adobe.setVariables'),
	setLinkClickVariables: () => dispatchEvent('adobe.setLinkClickVariables'),
	setVideoVariables: () => dispatchEvent('adobe.setVideoVariables'),
	setShareVariables: () => dispatchEvent('adobe.setShareVariables'),
};

export function setLocale(locale){
	window.HELIOS.adobe.tagging.languageCode = locale;
}

export function trackPage(pageName, pageType) {
	return chain = chain.then(async () => {
		try {
			window.HELIOS.adobe.tagging.pageName = pageName;
			window.HELIOS.adobe.tagging.pageType = 'nissan-dubai-expo:' + pageType;
			await fns.setVariables();

			window.s?.t();
		} catch (e) {
			console.error(e);
		}
	});
}

export function trackClick(componentName, buttonText, destination, locationInPage, isExternal) {
	const currentPage = window.location.href;
	return chain = chain.then(async () => {
		Object.assign(window.HELIOS.adobe.tagging.click, {
			buttonText,
			destination,
			currentPage,
			locationInPage,
		});

		window.HELIOS.adobe.tagging.componentName = componentName;

		await fns.setVariables();
		await fns.setLinkClickVariables();

		window.s?.tl(true, isExternal ? 'e' : 'o', buttonText);
	});
}

export function trackVideo(componentName, autoplay, name, interaction) {
	return chain = chain.then(async () => {
		// autoplay: '',
		// name: '',
		// interaction: '',
		// eventPlay: '',
		// eventCompleted: '',
		Object.assign(window.HELIOS.adobe.tagging.video, {
			autoplay: autoplay ? 'on' : 'off',
			name,
			interaction,
			eventPlay: interaction === 'play' ? 'play' : '',
			eventCompleted: interaction === 'complete' ? 'completed' : '',
		});

		window.HELIOS.adobe.tagging.componentName = componentName;

		await fns.setVariables();
		await fns.setVideoVariables();

		window.s?.tl(true, 'o', 'videoInteraction');
	});
	// let autoPlayValue = autoPlay ? 'on' : 'off';
	// V22: videoName|Video|autoplay|videoInteraction E34 (play), E35 (completed)
	// C53/V64: componentId
	// (note: videoComponentType is derived from the componentId; it takes the text value; here "Video")
}

export async function trackShare(componentName, url, interaction, action, network){
	return chain = chain.then(async () => {
		Object.assign(window.HELIOS.adobe.tagging.share, {
			url, interaction, action, network,
		});
		window.HELIOS.adobe.tagging.componentName = componentName;

		await fns.setVariables();
		await fns.setShareVariables();

		window.s?.tl(true, 'o', 'share');
	});
}

export async function trackGenericEvent(componentName, eventName){
	return chain = chain.then(async () => {
		window.HELIOS.adobe.tagging.componentName = componentName;

		await fns.setVariables();

		window.s?.tl(true, 'o', eventName);
	});
}

window.trackPage = trackPage;

window.trackClick = trackClick;

function prependLanguage(text){
	return `${window.HELIOS.adobe.tagging.languageCode}|${text}`;
}

const AriyaGameAnalytics  = {
	async TrackLoadingScreen(){
		return trackPage(prependLanguage('ariya-game-loading'), 'game');
	},
	async TrackGameIntroScreen(){
		return trackPage(prependLanguage('ariya-game-intro'), 'game');
	},
	async TrackPlayNow(){
		await trackClick('ariya-game', 'Play Now', null, 'ariya-game', false);
	},
	async TrackHowToPlayScreen1(){
		return trackPage(prependLanguage('ariya-game-how-to-play-1'), 'game');
	},
	async TrackHowToPlayScreen2(){
		return trackPage(prependLanguage('ariya-game-how-to-play-2'), 'game');
	},
	async TrackGamePlayScreen(){
		return trackPage(prependLanguage('ariya-game-play'), 'game');
	},
	async TrackZoneDriverControlled(){
		return trackGenericEvent('ariya-game', 'zone-enter:driver-controlled');
	},
	async TrackZoneProPilot(){
		return trackGenericEvent('ariya-game', 'zone-enter:pro-pilot');
	},
	async TrackZoneEforce(){
		return trackGenericEvent('ariya-game', 'zone-enter:e-force');
	},
	async TrackZoneComplete(){
		return trackGenericEvent('ariya-game', 'zone-complete');
	},
	async TrackFinalScreen(){
		return trackPage(prependLanguage('ariya-game-final'), 'game');
	},
	async TrackSeeMore(){
		return trackClick('ariya-game', 'See More', null, 'ariya-game', false);
	},
	async TrackPlayAgain(){
		await trackClick('ariya-game', 'Play Again', null, 'ariya-game', false);
	},
	async TrackTheNissanNext(){
		await trackClick('ariya-game', 'thenissannext.com', null, 'ariya-game', false);
	},
	async TrackHome(){
		return trackClick('ariya-game', 'Home', null, 'ariya-game', false);
	},
};

window.AriyaGameAnalytics = AriyaGameAnalytics;

export {AriyaGameAnalytics};